<script>
  import Tailwindcss from "./Tailwindcss.svelte";
  import Router from "svelte-spa-router";
  import Navbar from "./components/Navbar.svelte";
  import { Routes } from "./model/Routes";
  import LetterNavigation from "./components/LetterNavigation.svelte";
  import { getAllData } from "./services/letterService";
  import { onMount } from "svelte";
  import { replace, location } from "svelte-spa-router";
  import { checkJwtToken } from "./services/JwtHelper";
  import {
    setLoadingData,
    setRoute,
    setUserLoggedIn,
    userLoggedIn,
  } from "./services/store";
  import { i18nInit } from "./helper/i18n";
  import Icon from "fa-svelte";
  import { faArrowUp } from "@fortawesome/free-solid-svg-icons/faArrowUp";
  import Footer from "./components/Footer.svelte";
  onMount(() => {});
  init();

  let redirectedOnce = false;
  i18nInit();

  async function init() {
    // check if user is logged in
    let user = checkJwtToken();
    if (user) {
      setUserLoggedIn(true);
      setLoadingData(true);
      await getAllData();
      setLoadingData(false);
    } else {
      redirectToLogin();
    }
  }

  function redirectToLogin() {
    replace("/login");
  }

  function routeLoading(e) {
    setRoute($location);
    if (!$userLoggedIn && !redirectedOnce) {
      redirectToLogin();
      redirectedOnce = true;
    }
  }

  function goUp() {
    window.scroll(0, 0);
  }
</script>

<main class="bg-gradient-to-r from-gradient1 to-gradient2 ">
  <Tailwindcss />
  <Navbar />
  <LetterNavigation />
  <Router routes={Routes} on:routeLoading={routeLoading} />
  <Footer />
</main>
<button
  on:click={goUp}
  class="upButton
  pb-2 text-white bg-transparent border border-solid border-white hover:bg-white hover:text-primary-300 active:bg-primary-200 font-bold uppercase text-xs w-8 h-8 p-1 m-1 rounded-full outline-none focus:outline-none  ease-linear transition-all duration-150"
  type="button"
>
  <Icon icon={faArrowUp} />
</button>

<style>
  main {
    height: 100%;
    min-height: 100%;
  }
  .upButton {
    position: fixed;
    bottom: 15px;
    right: 1px;
    z-index: 999;
  }
</style>
